import logo from './logo.svg';
import './App.css';
import Intro from './intro';

function App() {
  return (
    <div className="App">
    <Intro/>
    </div>
  );
}

export default App;
